import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';
import { LocaleEnum } from 'src/app/submit-lecture/lecture.values';
import cities from '../../../../../../assets/data/cities.json';
import subdistricts from '../../../../../../assets/data/subdistricts.json';
import { ICity } from '../city.interface';


@Component({
    selector: 'city-details',
    templateUrl: './city-details.component.html',
    styleUrls: ['./city-details.component.scss']
})
export class CityDetailsComponent implements OnInit, OnDestroy {
    @Input() lang: string;
    @Input() selectedLocPrefs: any[];
    Object = Object;
    citiesMap = {};
    subscription;

    constructor(private activeModal: NgbActiveModal,
                private translate: TranslateService,
                private router: Router) {}
    options: AnimationOptions = {
        path: '/assets/animations/location.json',
        loop: true
    };

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit(): void {
        this.onLangChange(this.lang);

        this.subscription = this.translate.onLangChange
            .subscribe((event: LangChangeEvent) => {
                this.onLangChange(event.lang);
            });
    }

    private onLangChange(lang): void {
        this.lang = lang;
        this.selectedLocPrefs.forEach(loc => {
            const filtered: ICity[] = cities.filter(city => {
                return (city as ICity).subdistrict_id === loc;
            }).map(x => {
                if (this.lang === LocaleEnum.EN) {
                    return x.nameEN;
                } else {
                    return x.nameHE;
                }
            });

            if (filtered && filtered.length > 0) {
                const subdistName = subdistricts.filter(sub => {
                    return sub.id === loc;
                });
                if (this.lang === LocaleEnum.EN) {
                    this.citiesMap[subdistName[0]?.nameEN] = filtered;
                } else {
                    this.citiesMap[subdistName[0]?.nameHE] = filtered;
                }
            }
        });
    }

    closeModal(): void {
        this.activeModal.close({res: true});
    }

    navigateToProfile(): void {
        this.closeModal();
        this.router.navigate(['/profile']);
    }

}
